(() => {
  function parkDrawerMaps(drawer) {
    drawer.querySelectorAll('.frengee-store iframe').forEach((frame) => {
      const store = frame.closest('.frengee-store');
      if (!store) return;
      store.dataset.amcMapSrc = frame.src;
      frame.remove();
    });
  }

  function mountDrawerMaps(drawer) {
    drawer.querySelectorAll('.frengee-store[data-amc-map-src]').forEach((store) => {
      if (store.querySelector('iframe')) return;
      const address = store.querySelector('.frengee-store__address');
      if (!address) return;

      const frame = document.createElement('iframe');
      frame.src = store.dataset.amcMapSrc;
      frame.loading = 'lazy';
      frame.title = 'Store location map';
      frame.referrerPolicy = 'no-referrer-when-downgrade';
      frame.style.cssText = 'width:100%;height:180px;border:0;border-radius:8px;margin-top:10px;display:block;';
      address.insertAdjacentElement('afterend', frame);
    });
  }

  function enhancePickupDrawers(root = document) {
    root.querySelectorAll('.frengee-drawer').forEach((drawer) => {
      if (drawer.dataset.amcMapHandling === 'true') return;
      drawer.dataset.amcMapHandling = 'true';

      const syncMaps = () => {
        if (drawer.getAttribute('aria-hidden') === 'false') {
          mountDrawerMaps(drawer);
        } else {
          parkDrawerMaps(drawer);
        }
      };

      new MutationObserver(syncMaps).observe(drawer, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        childList: true,
        subtree: true
      });
      syncMaps();
    });
  }

  function enhanceSpecs(root = document) {
    root.querySelectorAll('.frengee-product-specifications').forEach((specs) => {
      if (!specs.querySelector('.amc-specs-intro')) {
        const header = specs.querySelector('.frengee-block-header');
        if (header) {
          const intro = document.createElement('p');
          intro.className = 'amc-specs-intro';
          intro.textContent = 'Compare the details that shape fit, feel, and performance.';
          header.insertAdjacentElement('afterend', intro);
        }
      }
    });
  }

  function enhanceProductGalleries(root = document) {
    root.querySelectorAll('.product-gallery').forEach((gallery) => {
      if (gallery.dataset.amcGalleryEnhanced === 'true') return;

      const swiperElement = gallery.querySelector('.gallery-top');
      const thumbnails = gallery.querySelector('.gallery-thumbs');
      const thumbnailLinks = thumbnails ? Array.from(thumbnails.querySelectorAll('a[data-media-id]')) : [];
      const previousButton = gallery.querySelector('.amc-gallery-thumbs-arrow--prev');
      const nextButton = gallery.querySelector('.amc-gallery-thumbs-arrow--next');
      const currentCount = gallery.querySelector('.amc-gallery-count__current');

      if (!swiperElement || !thumbnails || !previousButton || !nextButton || thumbnailLinks.length < 2) return;
      gallery.dataset.amcGalleryEnhanced = 'true';

      const updateScrollButtons = () => {
        const maxScroll = Math.max(0, thumbnails.scrollWidth - thumbnails.clientWidth);
        previousButton.disabled = thumbnails.scrollLeft <= 2;
        nextButton.disabled = thumbnails.scrollLeft >= maxScroll - 2;
      };

      const syncActiveThumbnail = (index, smooth = true) => {
        const activeIndex = Math.max(0, Math.min(index, thumbnailLinks.length - 1));
        const activeThumbnail = thumbnailLinks[activeIndex];

        thumbnailLinks.forEach((thumbnail, thumbnailIndex) => {
          const isActive = thumbnailIndex === activeIndex;
          thumbnail.classList.toggle('amc-thumb--active', isActive);
          if (isActive) {
            thumbnail.setAttribute('aria-current', 'true');
          } else {
            thumbnail.removeAttribute('aria-current');
          }
        });

        if (currentCount) currentCount.textContent = String(activeIndex + 1);

        const targetLeft = activeThumbnail.offsetLeft - (thumbnails.clientWidth - activeThumbnail.offsetWidth) / 2;
        thumbnails.scrollTo({ left: Math.max(0, targetLeft), behavior: smooth ? 'smooth' : 'auto' });
        window.setTimeout(updateScrollButtons, smooth ? 220 : 0);
      };

      const scrollThumbnails = (direction) => {
        thumbnails.scrollBy({ left: direction * thumbnails.clientWidth * .78, behavior: 'smooth' });
      };

      previousButton.addEventListener('click', () => scrollThumbnails(-1));
      nextButton.addEventListener('click', () => scrollThumbnails(1));
      thumbnails.addEventListener('scroll', updateScrollButtons, { passive: true });
      thumbnailLinks.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => window.setTimeout(() => syncActiveThumbnail(index), 0));
      });

      const connectSwiper = (attempt = 0) => {
        const swiper = swiperElement.swiper;
        if (!swiper || swiper.destroyed) {
          if (attempt < 40) window.setTimeout(() => connectSwiper(attempt + 1), 50);
          return;
        }
        swiper.on('slideChange', () => syncActiveThumbnail(swiper.activeIndex));
        syncActiveThumbnail(swiper.activeIndex, false);
      };

      connectSwiper();
      window.addEventListener('resize', updateScrollButtons, { passive: true });
    });
  }

  function init() {
    enhanceSpecs();
    enhancePickupDrawers();
    enhanceProductGalleries();
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => node.nodeType === 1))) {
        enhanceSpecs();
        enhancePickupDrawers();
        enhanceProductGalleries();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
